export enum SourceTypeEnum {
    journalist = 'CONTACT',
    outlet = 'OUTLET',
    url = 'URL',
    sourceGroup = 'SOURCE_GROUP'
};
